angular.module('duParallax', ['duScroll', 'duParallax.directive', 'duParallax.helper']);
